import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'app-banner-principal',
    templateUrl: './banner-principal.component.html',
    styleUrls: ['./banner-principal.component.scss'],
    standalone: false
})
export class BannerPrincipalComponent implements OnInit {
  @Input() imagen: string = '';
  @Input() h1: string = '';
  @Input() p: string = '';
  @Input() lista?: any = [];
  @Input() logo?: string = '';

  @Input() styleH1?: string = '';
  @Input() styleP?: string = '';
  @Input() styleCaption?: string = '';
  @Input() classCarousel?: string = '';

  constructor() { }

  ngOnInit(): void {
  }

}
